export const LISTINGS_ACCOUNT_INTEGRATIONS_SOQL = `SELECT
Id, 
Name, 
Third_Party_Ship_Billing__c,
Order_Integration__c, 
Order_Integration__r.Name,
Order_Integration__r.Listing_Name_Suffix__c,
Order_Integration__r.Autocreate__c,
Order_Integration__r.Auto_Enable_Listings__c,
Order_Integration__r.Country__c,
Wayfair_Retailer_Id__c,
Pack_to_Suit_Enabled__c,
Wayfair_Shipping_Account_Number__c,
Fedex_Account_Number__c,
UPS_Account_Number__c,
AccountCode__c,
Enable_Backorders__c,
DesktopShipperEnabled__c,
Requires_Ship_Notice__c,
Hours_to_Invoice__c
FROM 
Account 
WHERE
Account_Type__c = 'Sales Channel'
AND Order_Integration__c <> NULL 
ORDER BY
Name`

export const LISTINGS_PRODUCTS_SOQL = `SELECT CreatedDate, Id, MPN__c, UPC__c, Secondary_SKU__c, Secondary_UPC__c, Unauthorized_Countries__c, Marketing_Status__c, Image_URL_1__c, ASIN__c FROM Product2 WHERE Discontinued__c = false AND Status__c = 'In Stock' AND RecordType.Name = 'Product' AND Product2.Brand__c IN ('Sunnydaze Decor', 'CASL Brands', 'WaterLev', 'TankTop Covers') ORDER BY MPN__c`
export const LISTINGS_INTEGRATIONS_SOQL = `SELECT Id, Listing_Name_Suffix__c FROM Integration__c WHERE Autocreate__c = true`

export function getListingsProductById(productId: string){
  return `SELECT CreatedDate, Id, MPN__c, UPC__c, Secondary_SKU__c, Secondary_UPC__c, Unauthorized_Countries__c, Marketing_Status__c, Image_URL_1__c, ASIN__c FROM Product2 WHERE Id = '${productId}' AND RecordType.Name = 'Product' AND Product2.Brand__c IN ('Sunnydaze Decor', 'CASL Brands', 'WaterLev', 'TankTop Covers') ORDER BY CreatedDate DESC`
}

export function getPicklistValueStatusesByFieldNameSOQL(fieldName: string){
  return `SELECT 
  Label, 
  Value 
FROM 
  PicklistValueInfo 
WHERE 
  EntityParticle.EntityDefinition.QualifiedApiName = 'Listing__c' 
  AND EntityParticle.QualifiedApiName = '${fieldName}' 
  AND IsActive = true`
}

export function getListingsByIntegrationIdSOQL(integrationId: string){
  return `SELECT 
  Id, 
  Name,
  Amazon_US_Listing__c,
  SKU__c, 
  Enable__c, 
  Inventory_Status__c,
  Integration__c,
  Integration__r.Name,
  Integration__r.Listing_Name_Suffix__c,
  Integration__r.Country__c,
  External_Listing_ID__c,
  Pricing_Model__c,
  Marketplace_Cost__c,
  Promo_Marketplace_Cost__c,
  Delisted_Reason__c,
  CreatedDate,
  Product__c,
  Product__r.MPN__c,
  Product__r.Secondary_SKU__c,
  Product__r.Unauthorized_Countries__c,
  Product__r.Marketing_Status__c,
  Product__r.Image_URL_1__c,
  Product__r.UPC__c,
  Product__r.ASIN__c,
  Product__r.CreatedDate
FROM 
  Listing__c 
WHERE 
  Integration__r.Id = '${integrationId}'
  AND Product__r.Brand__c IN ('Sunnydaze Decor', 'CASL Brands', 'WaterLev', 'TankTop Covers')
  AND Product__r.RecordType.Name = 'Product'
ORDER BY
  Product__r.MPN__c`
} 

export function getListingsByProductIdSOQL(productId: string){
  return `SELECT 
  Id, 
  Name,
  Amazon_US_Listing__c,
  SKU__c, 
  Enable__c, 
  Inventory_Status__c,
  Integration__c,
  Integration__r.Name,
  Integration__r.Listing_Name_Suffix__c,
  Integration__r.Country__c,
  External_Listing_ID__c,
  Pricing_Model__c,
  Marketplace_Cost__c,
  Promo_Marketplace_Cost__c,
  Delisted_Reason__c,
  CreatedDate,
  Product__c,
  Product__r.MPN__c,
  Product__r.Secondary_SKU__c,
  Product__r.Unauthorized_Countries__c,
  Product__r.Marketing_Status__c,
  Product__r.Image_URL_1__c,
  Product__r.UPC__c,
  Product__r.ASIN__c,
  Product__r.CreatedDate
FROM 
  Listing__c 
WHERE 
  Product__c = '${productId}'
  AND Product__r.Brand__c IN ('Sunnydaze Decor', 'CASL Brands', 'WaterLev', 'TankTop Covers')
  AND Product__r.RecordType.Name = 'Product'
ORDER BY
  Integration__r.Name`
} 

//limit 1000
export function getListingOrderItemsByProductId(productId: string) {
  return `SELECT Id, Quantity, Order.Id, Order.Account.Id, Order.Account.Name, Order.Account.Order_Integration__c, Order.Name, Order.Status__c, Order.Order_Time__c, Listing__c, Listing__r.Name FROM OrderItem WHERE CreatedDate = LAST_N_MONTHS:6 AND Product2Id = '${productId}' ORDER BY Order.CreatedDate DESC LIMIT 1000`
}

//ignore Smart Warehouses (0011N00001ibmB5QAI)
export function getListingInventoryByProductId(productId: string) {
  return `SELECT Id, Bundle_Inventory__c, Name, Warehouse__c, Warehouse__r.Name, Live_Inventory__c, Fulfillable_Inventory__c, In_Transit_Total__c FROM Inventory__c WHERE Product__c = '${productId}' AND Warehouse__r.Parent.Id != '0011N00001ibmB5QAI' ORDER BY Name`
}

export function getListingAdjustmentsByProductId(productId: string) {
  return `SELECT Id, Quantity__c, Adjustment_Reason__c, Name, Inventory_Adjustment_Group__r.Adjustment_Reason__c, Inventory_Adjustment_Group__r.Source_Location__r.Name, Inventory_Adjustment_Group__r.Status__c, Inventory_Adjustment_Group__r.Id, Inventory_Adjustment_Group__r.Name, Inventory_Adjustment_Group__r.Shipment_Name__c, Target_Inventory__r.Warehouse__r.Name, Source_Inventory__r.Warehouse__r.Name, CreatedDate, Inventory_Adjustment_Group__r.Date_Received__c FROM Inventory_Adjustment__c WHERE Source_Inventory__r.Product__c = '${productId}' OR Target_Inventory__r.Product__c = '${productId}' ORDER BY CreatedDate DESC`
}

export function getListingInventoryMovementsByInventoryId(inventoryId: string){
  return `SELECT Id, Name, Movement_Type__c, Quantity__c, Related_Record_ID__c, Inventory_Transit_Status__c, CreatedDate FROM Inventory_Movements__c WHERE CreatedDate = LAST_N_MONTHS:6 AND Inventory__c = '${inventoryId}' ORDER BY CreatedDate DESC LIMIT 1000`
}

export function getProductIdByMpn(mpn: string){
  return `SELECT Id FROM Product2 WHERE MPN__c = '${mpn}'`
}

export function getAllProducts(){
  return `SELECT Id, MPN__c FROM Product2 WHERE Brand__c IN ('Sunnydaze Decor', 'CASL Brands', 'WaterLev', 'TankTop Covers') AND RecordType.Name = 'Product' ORDER BY MPN__c`
}